import { GcloudAccesses } from "@p0security/integrations-gcloud-shared/accesses";
import { Access, Delegate } from "@p0security/shared/types/access/index";

export const GcpCloudSqlAccesses = {
  resource: Access({
    label: "Database",
    description: "Grant user access to database",
    delegation: {
      gcloud: Delegate({
        resource: "gcloud",
        accesses: GcloudAccesses,
        key: "role" as const,
      }),
    },
    generated: {},
    maturity: "preview" as const,

    parameters: {
      instanceId: {
        type: "static",
        label: "GCP CloudSQL instance ID",
      },
      vpcId: {
        type: "static",
        label: "VPC ID",
      },
      engine: {
        type: "static",
        label: "Database engine",
        choices: ["postgres", "mysql"] as const,
        hidden: true,
      },
    },
    render: { locator: "instanceId" } as const,
  }),
};

export type GcpCloudSqlAccesses = typeof GcpCloudSqlAccesses;
